import HARDCODE from '../../../business-const/HardCode/HardCode'



const tipoLicencaList = [
    {
        id: HARDCODE.tipoLicencaCompleta, // HARDCODEBACKEND.tipoLicencaCompleta
        descricao: 'Completa',
        percDesconto: 0,
        exibirCompleto: 'S',
        exibirSimulacaoFinanceira: 'S',
        //exibirEstudo: 'S',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'S',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 2,
        ordem: 10,
    },
    {
        id: 'PE', // HARDCODEBACKEND.tipoLicencaCompletaEspecial
        descricao: 'Completa - Especial (50% desconto)',
        percDesconto: 50,
        exibirCompleto: 'S',
        exibirSimulacaoFinanceira: 'S',
        //exibirEstudo: 'S',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'S',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 3,
        ordem: 15,
    },
    {
        id: HARDCODE.tipoLicencaCorporativa, // HARDCODEBACKEND.tipoLicencaCorporativa
        descricao: 'Corporativa',
        percDesconto: 100,
        exibirCompleto: 'S',
        exibirSimulacaoFinanceira: 'S',
        //exibirEstudo: 'S',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'S',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 3,
        ordem: 20,
    },
    {
        id: 'CA', // HARDCODEBACKEND.tipoLicencaCorporativaAssessorInvestimentos
        descricao: 'Corporativa - Assessor de Investimentos',
        percDesconto: 100,
        exibirCompleto: 'N',
        exibirSimulacaoFinanceira: 'S',
        //exibirEstudo: 'N',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'N',//'S',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 3,
        ordem: 25,
    },
    {
        id: 'AI', // HARDCODEBACKEND.tipoLicencaAssessorInvestimentos
        descricao: 'Assessor de Investimentos (50% desconto)',
        percDesconto: 50, // HARDCODEBACKEND.percDescontoLicencaSimplificada
        exibirCompleto: 'N',
        exibirSimulacaoFinanceira: 'S',
        //exibirEstudo: 'N',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'N',//'S',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 1,
        ordem: 30,
    },
    {
        id: 'CS', // HARDCODEBACKEND.tipoLicencaCorretorSeguros
        descricao: 'Corretor de Seguros (50% desconto)',
        percDesconto: 50, // HARDCODEBACKEND.percDescontoLicencaSimplificada
        exibirCompleto: 'S',
        exibirSimulacaoFinanceira: 'N',
        //exibirEstudo: 'S',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'N',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 1,
        ordem: 50,
    },
    {
        id: 'LP',
        descricao: 'Life Planner',
        percDesconto: 0,
        exibirCompleto: 'S',
        exibirSimulacaoFinanceira: 'N',
        //exibirEstudo: 'S',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'N',
        menuEstudoConferenciaDados: 'S',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'N',
        nivel: 3,
        ordem: 50,
    },
    {
        id: HARDCODE.tipoLicencaPrevidenciaPrivada, // HARDCODEBACKEND.tipoLicencaPrevidenciaPrivada
        descricao: 'Previdência Privada (75% desconto)',
        percDesconto: 75, // HARDCODEBACKEND.percDescontoLicencaPrevidenciaPrivada
        exibirCompleto: 'N',
        exibirSimulacaoFinanceira: 'N',
        //exibirEstudo: 'N',
        exibirEstudoParametrosCompleto: 'N',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'N',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'S',
        exibirSomenteConsorcio: 'N',
        nivel: 1,
        ordem: 60,
    },
    {
        id: 'CN', // HARDCODEBACKEND.tipoLicencaConsorcio
        descricao: 'Consórcio (50% desconto)',
        percDesconto: 50, // HARDCODEBACKEND.percDescontoLicencaSimplificada
        exibirCompleto: 'S',
        exibirSimulacaoFinanceira: 'N',
        //exibirEstudo: 'S',
        exibirEstudoParametrosCompleto: 'S',
        exibirAcumulacaoAposentadoriaProjetoVidaSonho: 'N',//'S',
        menuEstudoConferenciaDados: 'N',
        exibirSomentePrevidenciaPrivada: 'N',
        exibirSomenteConsorcio: 'S',
        nivel: 1,
        ordem: 70,
    },
 ]
  
 export default tipoLicencaList